import { useSelector } from 'react-redux'
import { MAP_BUTTON_MODE, MAP_BUTTON_THEME, MAP_MODES, MAP_THEMES } from '../../../store/map/map.constants'
import { selectActiveMapEvents } from '../../../store/map/map.selectors'
import ThemeDark from './theme-dark.svg'
import ThemeNature from './theme-nature.svg'
import ThemeSatellite from './theme-satellite.png'
import ThemeSimple from './theme-simple.svg'
import ThemeStandard from './theme-standard.svg'
import { useEffect, useState } from 'react'

const themeButtons = [
  {
    key: MAP_THEMES.normal,
    icon: ThemeStandard,
    type: MAP_BUTTON_THEME,
    availableInRaster: true
  },
  {
    key: MAP_THEMES.simple,
    icon: ThemeSimple,
    type: MAP_BUTTON_THEME,
    availableInRaster: false
  },
  {
    key: MAP_THEMES.nature,
    icon: ThemeNature,
    type: MAP_BUTTON_THEME,
    availableInRaster: false
  },
  {
    key: MAP_THEMES.satellite,
    icon: ThemeSatellite,
    type: MAP_BUTTON_THEME,
    availableInRaster: true
  },
  {
    key: MAP_THEMES.dark,
    icon: ThemeDark,
    type: MAP_BUTTON_THEME,
    availableInRaster: false
  }
]
const modeButtons = [
  {
    key: MAP_MODES.neutral,
    icon: 'neutral',
    type: MAP_BUTTON_MODE,
    availableInRaster: true
  },
  {
    key: MAP_MODES.traffic,
    icon: 'traffic-outline',
    type: MAP_BUTTON_MODE,
    availableInRaster: true
  },
  {
    key: MAP_MODES.zfe,
    icon: 'critair-outline',
    type: MAP_BUTTON_MODE,
    availableInRaster: false
  },
  {
    key: MAP_MODES.bicycle,
    icon: 'bike-outline',
    type: MAP_BUTTON_MODE,
    availableInRaster: true
  },
  {
    key: MAP_MODES.tc,
    icon: 'subway-outline',
    type: MAP_BUTTON_MODE,
    availableInRaster: true
  }
]

export const useMapThemeButtons = () => themeButtons

export const useMapModeButtons = () => {
  const activeMapEvents = useSelector(selectActiveMapEvents)

  const [buttons, setButtons] = useState(modeButtons)
  useEffect(() => {
    const buttons = [...modeButtons]
    buttons.splice(1, 0, ...activeMapEvents)
    setButtons(buttons)
  }, [activeMapEvents])

  return buttons
}
